import { Container, Row, Col } from 'react-bootstrap'
import LoginForm from "./LoginForm";


function Login() {
    return (

        <Container>
            <Row className="justify-content-evenly">
                <Col >
                    <LoginForm />
                </Col>
            </Row>
        </Container>

    );
}

export default Login;
